import Container from 'react-bootstrap/Container';
import Slider from "react-slick";
import Image from 'react-bootstrap/Image';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './brandsblock.css';

function BrandsBlock() {
const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false, // ← отключаем стрелки
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const brands = [
    "centek", "daichi", "midea", "gree", "kentatsu",
    "haier", "lessar", "berlingtoun", "funai", "electrolux", "newtek"
  ];

  return (
    <div className="brands-block-wrapper py-5">
      <Container className="text-center mb-4">
        <h3 className="fs-4 evotextb">
          ОФИЦИАЛЬНЫЙ ДИЛЕР<br />
          КЛИМАТИЧЕСКОГО ОБОРУДОВАНИЯ
        </h3>
        <span className="evotext text-secondary fw-normal">
          Интернет-магазин «ЭВОСЕМЬ» предлагает разнообразный ассортимент кондиционеров
          и климатической техники<br />
          высокого качества по приемлемым ценам от ведущих производителей.
        </span>
      </Container>

      <Container className="brands_slider px-3">
        <Slider {...settings}>
          {brands.map((brand, index) => (
            <div key={index} className="brand-slide px-2">
              <Image
                src={`/images/brands/${brand}.jpg`}
                alt={brand}
                className="brand-img mx-auto"
                fluid
              />
            </div>
          ))}
        </Slider>
      </Container>
    </div>
  );
}

export default BrandsBlock;
